import state from './notifyState'
import mutations from './notifyMutations'
import actions from './notifyActions'
import getters from './notifyGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
